import React, { useState } from "react";
// import "./Detail.css";
import { Card, Col, Row, Container } from "react-bootstrap";
import { FaPhone, FaUser } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
const OphthalmologyDetail = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
  });
  const [message, setMessage] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation (simple example)
    if (!formData.name || !formData.phone || !formData.email) {
      setMessage("All fields are required!");
      return;
    }

    try {
      const response = await axios.post(
        "http://localhost:4000/api/send-mail",
        formData
      );
      setMessage(response.data.message || "Request sent successfully!");
    } catch (error) {
      setMessage("Failed to send the request. Please try again.");
    }
  };
  return (
    <section className="space shape-mockup-wrap">
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-lg-7">
            <div className="page-single">
              <div className="page-meta" style={{ marginTop: "0px" }}>
                <Link className="page-tag">
                  Ophthalmology Services at Surgery Saathi
                </Link>{" "}
              </div>

              <div className="page-content d-block">
                <p className="box-text mb-30 detail-page-paraas">
                  Your vision is one of your most precious assets. At Surgery
                  Saathi, we provide cutting-edge ophthalmology services to
                  ensure your eyes stay healthy and your vision remains sharp.
                  From diagnostics to advanced surgical procedures, we partner
                  with the best surgeons and hospitals to deliver world-class
                  eye care.
                </p>

                <div className="service-inner-img mb-40">
                  <img
                    src="https://img.freepik.com/premium-photo/optometrist-examining-female-patient-slit-lamp_107420-71209.jpg?w=900"
                    // src="https://img.freepik.com/premium-photo/doctor-conducting-virtual-consultation-with-patient_1280275-220305.jpg?w=900"
                    alt=""
                    style={{ height: "300px", objectFit: "cover" }}
                  />
                </div>
                <p
                  className="box-text mb-30 detail-page-paraas"
                  style={{
                    background: "aliceblue",
                    padding: "10px",
                    fontStyle: "italic",
                  }}
                >
                  Cataract removal restores vision, alleviates blurry or
                  impaired vision, and resolves complications impacting daily
                  activities caused by this common condition.
                </p>
              </div>
              {/* <p className="box-text mb-30 detail-page-paraas">
              For those seeking to enhance appearance, surgery is typically
              recommended only after nasal growth has completed, while
              functional corrections can be performed at a younger age.
            </p> */}
              <div className="th-comments-wrap style2">
                <h2 className="blog-inner-title h4">
                  Our Ophthalmology Services
                </h2>
              </div>
              <Row>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-1.jpeg"
                    alt=""
                    className="opthamalogy_image" //eyezenith.com/_next/image?url=https%3A%2F%2Fcdn.durable.co%2Fshutterstock%2F8yv9qi9UtlwKUfS4M7wzBVzpjtJMyRmvu7IOydU11COWxPwJ64GG59kgCtD43wR2.jpeg&w=1920&q=90
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      LASIK Surgery
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      Regain clear vision with LASIK, a safe and effective laser
                      eye surgery for correcting refractive errors such as
                      nearsightedness, farsightedness, and astigmatism.
                    </p>
                    <p
                      style={{
                        marginTop: "15px",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      <b>Benefits:</b> Quick recovery, long-lasting results, and
                      freedom from glasses or contact lenses.
                    </p>
                    <p
                      style={{
                        marginTop: "10px",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      Procedure Time: 15–30 minutes.
                    </p>
                    <p style={{ margin: "0px", fontSize: "14px" }}>
                      Downtime: Minimal.
                    </p>
                  </div>
                </Col>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-7.jpeg"
className="opthamalogy_image"
                     alt=""
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      Cataract Surgery
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      Restore your vision and quality of life with advanced
                      cataract removal techniques.
                    </p>
                    <p
                      style={{
                        marginTop: "15px",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      <b>Techniques:</b> Phacoemulsification or laser-assisted
                      surgery.
                    </p>
                    <p
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      <b>Benefits:</b> Painless procedure with improved vision
                      clarity.
                    </p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-9.jpeg"
className="opthamalogy_image"
                     alt=""
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      ICL (Implantable Collamer Lens) Treatment
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      Treat conditions like keratoconus or corneal scarring with
                      state-of-the-art surgical solutions, including corneal
                      transplants.
                    </p>
                  </div>
                </Col>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-6.jpeg"
className="opthamalogy_image"
                     alt=""
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      Glaucoma Treatment
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      Early detection and treatment of glaucoma can prevent
                      vision loss. Our specialists provide a range of
                      treatments, including medication, laser therapy, and
                      surgical options.
                    </p>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-3.jpeg"
className="opthamalogy_image"
                     alt=""
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      Corneal Surgery
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      Treat conditions like keratoconus or corneal scarring with
                      state-of-the-art surgical solutions, including corneal
                      transplants.
                    </p>
                  </div>
                </Col>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
src="/Images/ortho-10.jpeg"
className="opthamalogy_image"
                     alt=""
                  />
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      Pediatric Eye Care
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      We also specialize in treating vision issues in children,
                      such as strabismus (squint), lazy eye, or refractive
                      errors.
                    </p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} style={{ marginTop: "15px" }}>
                  {" "}
                  <img
                    className="opthamalogy_image"
                     alt=""
src="/Images/artho-13.jpeg"
/>
                  <div style={{ marginTop: "15px" }}>
                    <h2 className="mb-2" style={{ fontSize: "22px" }}>
                      Refractive Lens Exchange (RLE)
                    </h2>
                    <p className="" style={{ fontSize: "14px" }}>
                      For those not eligible for LASIK, RLE is an excellent
                      option for correcting vision by replacing the eye's
                      natural lens with an artificial one.
                    </p>
                    <p
                      style={{
                        marginTop: "15px",
                        marginBottom: "0px",
                        fontSize: "14px",
                      }}
                    >
                      <b>Best For:</b> Individuals with severe refractive errors
                      or early cataracts.
                    </p>
                  </div>
                </Col>
              </Row>
              {/* <div className="th-comments-wrap style2">
                <h2 className="blog-inner-title h4">
                  Our Ophthalmology Services
                </h2>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">LASIK Surgery</h3>
                        <p className="text">
                          Regain clear vision with LASIK, a safe and effective
                          laser eye surgery for correcting refractive errors
                          such as nearsightedness, farsightedness, and
                          astigmatism.
                        </p>
                        <p style={{ marginTop: "15px", marginBottom: "0px" }}>
                          <b>Benefits:</b> Quick recovery, long-lasting results,
                          and freedom from glasses or contact lenses.
                        </p>
                        <p style={{ marginTop: "10px", marginBottom: "0px" }}>
                          Procedure Time: 15–30 minutes.
                        </p>
                        <p style={{ margin: "0px" }}>Downtime: Minimal.</p>
                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Cataract Surgery</h3>
                            </div>
                            <p className="text">
                              Restore your vision and quality of life with
                              advanced cataract removal techniques.
                            </p>
                            <p
                              style={{ marginTop: "15px", marginBottom: "0px" }}
                            >
                              <b>Techniques:</b> Phacoemulsification or
                              laser-assisted surgery.
                            </p>
                            <p
                              style={{ marginTop: "0px", marginBottom: "0px" }}
                            >
                              <b>Benefits:</b> Painless procedure with improved
                              vision clarity.
                            </p>
                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">Refractive Lens Exchange (RLE)</h3>
                        <p className="text">
                          For those not eligible for LASIK, RLE is an excellent
                          option for correcting vision by replacing the eye's
                          natural lens with an artificial one.
                        </p>
                        <p style={{ marginTop: "15px", marginBottom: "0px" }}>
                          <b>Best For:</b> Individuals with severe refractive
                          errors or early cataracts.
                        </p>

                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Glaucoma Treatment</h3>
                            </div>
                            <p className="text">
                              Early detection and treatment of glaucoma can
                              prevent vision loss. Our specialists provide a
                              range of treatments, including medication, laser
                              therapy, and surgical options.
                            </p>

                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul className="comment-list">
                  <li className="th-comment-item">
                    <div className="th-post-comment">
                      <div className="comment-content">
                        <h3 className="name">Corneal Surgery</h3>
                        <p className="text">
                          Treat conditions like keratoconus or corneal scarring
                          with state-of-the-art surgical solutions, including
                          corneal transplants.
                        </p>

                        <div className="reply_and_edit">
                          <i className="fa-solid fa-thumbs-up" />
                        </div>
                      </div>
                    </div>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">Pediatric Eye Care </h3>
                            </div>
                            <p className="text">
                              We also specialize in treating vision issues in
                              children, such as strabismus (squint), lazy eye,
                              or refractive errors.
                            </p>

                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul className="comment-list">
                      <li className="th-comment-item">
                        <div className="th-post-comment">
                          <div className="comment-content">
                            <div className="">
                              <h3 className="name">ICL (Implantable Collamer Lens) Treatment</h3>
                            </div>
                            <p className="text">
                            ICL is an advanced and safe solution for vision correction, ideal for individuals not eligible for LASIK or those with high refractive errors.
                            </p>

                            <div className="reply_and_edit">
                              <i className="fa-solid fa-thumbs-up" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div> */}

              <div style={{ marginTop: "0px" }}>
                <h2
                  className="box-title"
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    background: "aliceblue",
                    padding: "10px",
                  }}
                >
                  What It Is: A soft, flexible lens implanted between the iris
                  and your natural lens to correct nearsightedness,
                  farsightedness, or astigmatism.
                </h2>
              </div>

              <h2
                className="box-title"
                style={{ fontSize: "20px", marginTop: "30px" }}
              >
                Benefits of Ophthalmology :
              </h2>
              {/* <div style={{ marginTop: "50px" }}>
              <h2 className="box-title">Post-Operative Care</h2>
            </div> */}
              <div>
                <div className="checklist" style={{ marginTop: "15px" }}>
                  <ul>
                    <li>Suitable for high prescriptions.</li>
                    <li>Reversible and removable if needed.</li>

                    <li>
                      No corneal reshaping required, preserving corneal
                      integrity.
                    </li>
                    <li>Provides UV protection.</li>
                    <li>Procedure Time: 20–30 minutes.</li>
                  </ul>
                </div>
              </div>

              {/* <div>
              <p
                className="box-text detail-page-paraas"
                style={{ margin: "5px" }}
              >
                Involves a small incision at the base of the nose, providing
                greater visibility and access for extensive reshaping. This
                technique is ideal for significant alterations.
              </p>
              <div className="checklist" style={{ marginTop: "15px" }}>
                <ul>
                  <li>
                    Autologous cartilage grafts taken from the nasal septum
                    (the wall inside the nose that divides one air passage
                    from the other) offers the best chance for a natural
                    result. If cartilage and bone have already been removed
                    from the nasal septum, then ear or rib cartilage and
                    sometimes bone from the skull are other options.
                  </li>
                  <li>
                    Although solid silicone implants are available for nasal
                    surgery, these are foreign materials that may become
                    infected or react poorly with the nasal tissues and have
                    to be removed. That is why natural cartilage, if a supply
                    is available, is the most trouble-free option.
                  </li>

                  <li>
                    Fillers or fat grafts may also be injected to smooth the
                    nose, to camouflage deformities or indentations, or to add
                    volume in desired areas.
                  </li>
                </ul>
              </div>
            </div> */}
              <div style={{ marginTop: "20px" }}>
                <h2
                  className="box-title"
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    background: "aliceblue",
                    padding: "10px",
                  }}
                >
                  Recovery Time: Minimal, with improved vision noticeable almost
                  immediately.
                </h2>
              </div>

              {/* <div style={{ marginTop: "50px" }}>
              <h2 className="box-title">Expected Results and Recovery</h2>
            </div> */}
              {/* <p
              className="box-text detail-page-paraas"
              style={{ margin: "5px" }}
            >
              Swelling generally subsides within weeks, with final results
              becoming clear over time. Most patients can return to daily
              activities within a week, while strenuous activities should be
              avoided for about two to three weeks.
            </p> */}
            </div>
          </div>
          <div className="col-xxl-4 col-lg-5">
            <aside className="sidebar-area style3">
              <div className="breakcrumbss">
                <div className="aside-detail-firstdivc">Popular Services</div>
                <ul className="detail-page-uls">
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/ophthalmology">Ophthalmology</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/gynaecomastia">Gynecomastia</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/rhinoplasty">Rhinoplasty</Link>
                  </li>
                  <li className="detail-pager-frst-ul-li">
                    <Link to="/lipoma-removal">Lipoma Removal</Link>
                  </li>
                </ul>
              </div>
              <div className="breakcrumbss" style={{ marginTop: "30px" }}>
                <div className="aside-detail-firstdivc">Get Appointment</div>
                <form onSubmit={handleSubmit}>
                  <Row style={{ marginTop: "30px" }}>
                    <Col md={12} style={{ position: "relative" }}>
                      <FaUser
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="name"
                          className="aside-input-appointement"
                          placeholder="Name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <FaPhone
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="phone"
                          className="aside-input-appointement"
                          placeholder="Mobile Number"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12} style={{ position: "relative" }}>
                      <MdEmail
                        color="#0f80a5"
                        className="aside-icons-react-apppointment"
                      />
                      <span style={{ position: "relative" }}>
                        <input
                          type="email"
                          name="email"
                          className="aside-input-appointement"
                          placeholder="Email Id"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>

                    <Col md={12}>
                      <button type="submit" className="aside-appointment-btn">
                        Get Appointment
                      </button>
                    </Col>
                  </Row>
                </form>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OphthalmologyDetail;
